export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-Latin2-96387dbec83b4f206c902298da42a3d3.woff2";